export const CMS_WIDGETS_LIST = 'CMS_WIDGETS_LIST';
export const CMS_WIDGET_DETAILS_BY_ID = 'CMS_WIDGET_DETAILS_BY_ID';
